<template>
    <div>
        <div class="settings-item" @click="onOpen">
            <div class="icon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <g id="location" transform="translate(-428 -188)">
                        <path
                            id="Vector"
                            d="M6.24,3.12A3.12,3.12,0,1,1,3.12,0,3.12,3.12,0,0,1,6.24,3.12Z"
                            transform="translate(436.88 195.19)"
                            fill="none"
                            stroke="#12202b"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-2"
                            data-name="Vector"
                            d="M.243,6.49c1.97-8.66,14.8-8.65,16.76.01,1.15,5.08-2.01,9.38-4.78,12.04a5.193,5.193,0,0,1-7.21,0C2.253,15.88-.907,11.57.243,6.49Z"
                            transform="translate(431.377 190)"
                            fill="none"
                            stroke="#12202b"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-3"
                            data-name="Vector"
                            d="M0,0H24V24H0Z"
                            transform="translate(452 212) rotate(180)"
                            fill="none"
                            opacity="0"
                        />
                    </g>
                </svg>
            </div>
            <div class="name">
                <span>ფილიალები</span>
                <p>მიუთითეთ სად გნებავთ, რომ ჩამოვიდეს თქვენი ამანათები</p>
            </div>
            <div class="spacer"></div>
            <button>
                <svg
                    id="arrow-right"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                >
                    <path
                        id="Vector"
                        d="M0,13.2,5.433,7.767a1.655,1.655,0,0,0,0-2.333L0,0"
                        transform="translate(7.425 3.4)"
                        fill="none"
                        stroke="rgba(18,32,43,0.5)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                    />
                    <path
                        id="Vector-2"
                        data-name="Vector"
                        d="M0,0H20V20H0Z"
                        transform="translate(20 20) rotate(180)"
                        fill="none"
                        opacity="0"
                    />
                </svg>
            </button>
        </div>
        <transition name="fade">
            <div class="modals" v-show="modal">
                <div class="modals-inner">
                    <h2 class="modals-inner-title">ფილიალები</h2>
                    <button class="modals-inner-closer" @click="modal = false">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12.121"
                            height="12.121"
                            viewBox="0 0 12.121 12.121"
                        >
                            <g
                                id="close-circle"
                                transform="translate(-244.109 -260.109)"
                            >
                                <path
                                    id="Vector"
                                    d="M0,10,10,0"
                                    transform="translate(245.17 261.17)"
                                    fill="none"
                                    stroke="#12202b"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                />
                                <path
                                    id="Vector-2"
                                    data-name="Vector"
                                    d="M10,10,0,0"
                                    transform="translate(245.17 261.17)"
                                    fill="none"
                                    stroke="#12202b"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                />
                            </g>
                        </svg>
                    </button>

                    <div class="models-user" v-if="userInfo">
                        <div class="avatar">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <g
                                    id="profile"
                                    transform="translate(-108 -252)"
                                >
                                    <path
                                        id="Vector"
                                        d="M4.6,8.87a1.818,1.818,0,0,0-.33,0,4.445,4.445,0,1,1,.33,0Z"
                                        transform="translate(115.56 254)"
                                        fill="none"
                                        stroke="#12202b"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    ></path>
                                    <path
                                        id="Vector-2"
                                        data-name="Vector"
                                        d="M1.815,1.373c-2.42,1.62-2.42,4.26,0,5.87a9.766,9.766,0,0,0,10.01,0c2.42-1.62,2.42-4.26,0-5.87A9.812,9.812,0,0,0,1.815,1.373Z"
                                        transform="translate(113.345 265.188)"
                                        fill="none"
                                        stroke="#12202b"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    ></path>
                                    <path
                                        id="Vector-3"
                                        data-name="Vector"
                                        d="M0,0H24V24H0Z"
                                        transform="translate(132 276) rotate(180)"
                                        fill="none"
                                        opacity="0"
                                    ></path>
                                </g>
                            </svg>
                        </div>
                        <div class="name">
                            <p>
                                {{ userInfo.first_name_ge }}
                                {{ userInfo.last_name_ge }}
                            </p>
                            <span>
                                {{ userInfo.first_name }}
                                {{ userInfo.last_name }}
                            </span>
                        </div>
                    </div>

                    <!-- {{ userInfo }}

                    {{ cites }} -->

                    <ValidationObserver
                        ref="observer"
                        v-slot="{ handleSubmit }"
                    >
                        <form
                            method="post"
                            @submit.prevent="handleSubmit(onSave)"
                            @keyup.enter="handleSubmit(onSave)"
                        >
                            <ValidationProvider
                                v-slot="{ errors }"
                                rules="required"
                                tag="div"
                            >
                                <div
                                    :class="{
                                        'select-input': true,
                                        'is-invalid': errors[0] ? true : false,
                                    }"
                                >
                                    <v-select
                                        v-if="cites"
                                        :searchable="true"
                                        :options="cites"
                                        v-model="city"
                                        labelTitle="მონიშნეთ ქალაქი"
                                        labelNotFound="ჩანაწერი ვერ მოიძებნა"
                                        labelSearchPlaceholder="ძიება"
                                    />
                                </div>
                                <span
                                    v-if="errors[0]"
                                    class="invalid-feedback"
                                    role="alert"
                                >
                                    <strong>{{ errors[0] }}</strong>
                                </span>
                            </ValidationProvider>

                            <ValidationProvider
                                v-slot="{ errors }"
                                rules="required"
                                tag="div"
                            >
                                <div
                                    :class="{
                                        'select-input': true,
                                        'is-invalid': errors[0] ? true : false,
                                    }"
                                >
                                    <v-select
                                        v-if="brenchs"
                                        :searchable="true"
                                        :options="brenchs"
                                        v-model="brench"
                                        labelTitle="მონიშნეთ ფილიალი"
                                        labelNotFound="ჩანაწერი ვერ მოიძებნა"
                                        labelSearchPlaceholder="ძიება"
                                    />
                                </div>
                                <span
                                    v-if="errors[0]"
                                    class="invalid-feedback"
                                    role="alert"
                                >
                                    <strong>{{ errors[0] }}</strong>
                                </span>
                            </ValidationProvider>

                            <button class="calculator-button" type="submit">
                                შენახვა
                            </button>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {
    defineComponent,
    onBeforeMount,
    onMounted,
    reactive,
    ref,
    watch,
} from "@vue/composition-api";
import { useUser } from "../../hooks/user";
import axios from "axios";
import { Notyf } from "notyf";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VSelect from "@alfsnd/vue-bootstrap-select";
import Swal from "sweetalert2";

export default defineComponent({
    components: {
        ValidationObserver,
        ValidationProvider,
        VSelect,
    },
    setup(_, { root }) {
        const modal = ref(false);
        const city = ref(null);
        const brench = ref(null);

        const { getUser, userInfo, getCites, cites, getBrench, brenchs } =
            useUser();

        const BodyFix = (status) => {
            const body = document.body;

            if (status) {
                body.style.overflow = "hidden";
            } else {
                body.style.overflow = "scroll";
            }
        };

        const onSave = () => {
            axios({
                method: "post",
                url: "api/brench/update",
                data: {
                    id: userInfo.value.id,
                    city: city.value.value,
                    brench: brench.value.value,
                },
            }).then((e) => {
                modal.value = false;
                if (e.data.status) {
                    Swal.fire({
                        icon: "success",
                        title: "გაფრთხილება ფილიალის ცვლილება ამოქმედდება საწყობის გრაფაში ასახულ ამანათებზე, გამოგზავნილი და ჩამოსული რეისების ამანათებზე ფილიალის ცვლილება არ ამოქმედდება.",
                        confirmButtonText: "დახურვა",
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: e.data.mass,
                        confirmButtonText: "დახურვა",
                    });
                }
            });
        };

        watch(
            () => modal.value,
            (newVal, OldVal) => {
                BodyFix(newVal);
            }
        );

        onBeforeMount(async () => {
            if (!userInfo.value) {
                await getUser();
            }
            await getCites();
            city.value = cites.value.find(
                (e) => e.value == userInfo.value.city_id
            );
        });

        const onOpen = async () => {
            root.$vs.loading({ color: "#f39120" });

            const { data } = await axios({
                method: "GET",
                url: "api/warehouse/check",
            });
            root.$vs.loading.close();

            if (data.update) {
                modal.value = true;
            } else {
                Swal.fire({
                    icon: "error",
                    title: "გაფრთხილება ფილიალის ცვლილება არ არის შესაძლებელი ვინაიდან საწყობის გრაფაში უკვე ასახული გაქვთ ამანათი, გთხოვთ ფილაილი შეცვალეთ როდესაც რეისი გამოიგზავნება და საწყობის გრაფაში არ იქნება ამანათი ასახული. გაითვალისწინეთ გამოგზავნილი რეისის ამანათებზე ფილიალის ცვლილება არ იმოქმედებს.",
                    confirmButtonText: "დახურვა",
                });
            }
        };

        watch(
            () => city.value,
            async (newVal, oldVal) => {
                if (newVal != oldVal) {
                    // brench.value = null;
                    await getBrench(newVal.value);
                    brench.value = brenchs.value.find(
                        (e) => e.value == userInfo.value.branch_id
                    );
                }
            }
        );
        return {
            userInfo,
            modal,
            cites,
            brenchs,
            onSave,
            city,
            brench,
            onOpen,
        };
    },
});
</script>
